// extracted by mini-css-extract-plugin
module.exports = {"AiOkayDoctorPackage":"C-2YaGudAw6nYxYO0IwhS"};